export const UPSERT_USER_COVERAGE = `
mutation upsertUserCoverage($input: UpsertCoverageInput!) {
  upsertUserCoverage(input: $input) {
    __typename
    ... on SuccessfulResponse {
      status
      status_message
    }
    ... on ResultError {
      status_code
      message
    }
  }
}
`;
